import config from "@/config";
import { requests } from ".";

const PAYMENT_SERVER_URL = config?.PAYMENT_SERVER_URL;
const PRODUCT_SERVER_URL = config?.PRODUCT_SERVER_URL;

interface PRODUCT_LIST {
  locationId: String;
  search?: String;
  skip?: Number;
  limit?: Number;
  productIds?: Array<String>;
}

interface CREATE_PRODUCT {
  locationId: String;
  name: String;
  productType: String;
  medias: Array<String>;
  availableInStore: Boolean;
  seo: {
    title: String;
    description: String;
  };
  variants: Array<String>;
  isTaxesEnabled: Boolean;
  isLabelEnabled: Boolean;
  prices: Array<PRODUCT_PRICE>;
  meta: {
    internalSource: String;
  };
}

interface PRODUCT_PRICE {
  name: String;
  type: String;
  currency: String;
  amount: Number;
  recurring: {
    interval: String;
    intervalCount: Number;
  };
}

export const PaymentServices = {
  integrations: (locationId: String) =>
    requests(PAYMENT_SERVER_URL).get(`/payments/integrations/${locationId}`),
  getCurrency: () => requests(PAYMENT_SERVER_URL).get("/payments/currency"),
  getProductList: (params: PRODUCT_LIST) =>
    requests(PRODUCT_SERVER_URL).get("/products/", {
      params: params,
    }),
  createProduct: (body: CREATE_PRODUCT) => requests(PRODUCT_SERVER_URL).post("/products/", body),
};
